<template>
  <div>
    <div :id="id" :style="{ height: height - 32 + 'px' }" />
    <NoDataOverlay :model-value="!(value && value.length)" />
  </div>
</template>
  
  <script>
import * as echarts from "echarts";
import themeJson from "@/assets/echarts-themes/oceanic-balanced.json";
import { v4 as uuidv4 } from "uuid";
import NoDataOverlay from "@/components/atoms/analytics/NoDataOverlay.vue";

export default {
  name: "RealTimePerformanceFunnel",
  components: {
    NoDataOverlay,
  },
  props: {
    id: {
      type: String,
      default: `real-time-performance-${uuidv4()}`,
    },
    value: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      chartInstance: null,
      resizeObserver: null,
    };
  },
  watch: {
    value: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
    this.observeResize();
  },
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  methods: {
    renderChart() {
      const chartDom = document.getElementById(this.id);
      if (!chartDom) return;

      const chart = echarts.init(chartDom, themeJson.themeName);
      chart.setOption(this.getOptions());

      this.chartInstance = chart;
    },
    observeResize() {
      const chartDom = document.getElementById(this.id);
      if (!chartDom) return;

      this.resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          this.chartInstance?.resize();
        });
      });

      this.resizeObserver.observe(chartDom);
    },
    getOptions() {
      return {
        title: [
          {
            left: "center",
            text: "Gradient along the y axis",
          },
          {
            top: "33%",
            left: "center",
            text: "Gradient along the x axis",
          },
          {
            top: "66%",
            left: "center",
            text: "Gradient along the x axis",
          },
        ],
        tooltip: {
          trigger: "axis",
        },
        xAxis: [
          {
            data: [
              "2000-06-05",
              "2000-06-06",
              "2000-06-07",
              "2000-06-08",
              "2000-06-09",
              "2000-06-10",
              "2000-06-11",
              "2000-06-12",
              "2000-06-13",
              "2000-06-14",
              "2000-06-15",
              "2000-06-16",
              "2000-06-17",
              "2000-06-18",
              "2000-06-19",
              "2000-06-20",
              "2000-06-21",
              "2000-06-22",
              "2000-06-23",
              "2000-06-24",
              "2000-06-25",
              "2000-06-26",
              "2000-06-27",
              "2000-06-28",
              "2000-06-29",
              "2000-06-30",
              "2000-07-01",
              "2000-07-02",
              "2000-07-03",
              "2000-07-04",
              "2000-07-05",
              "2000-07-06",
              "2000-07-07",
              "2000-07-08",
              "2000-07-09",
              "2000-07-10",
              "2000-07-11",
              "2000-07-12",
              "2000-07-13",
              "2000-07-14",
              "2000-07-15",
              "2000-07-16",
              "2000-07-17",
              "2000-07-18",
              "2000-07-19",
              "2000-07-20",
              "2000-07-21",
              "2000-07-22",
              "2000-07-23",
              "2000-07-24",
            ],
          },
          {
            data: [
              "2000-06-05",
              "2000-06-06",
              "2000-06-07",
              "2000-06-08",
              "2000-06-09",
              "2000-06-10",
              "2000-06-11",
              "2000-06-12",
              "2000-06-13",
              "2000-06-14",
              "2000-06-15",
              "2000-06-16",
              "2000-06-17",
              "2000-06-18",
              "2000-06-19",
              "2000-06-20",
              "2000-06-21",
              "2000-06-22",
              "2000-06-23",
              "2000-06-24",
              "2000-06-25",
              "2000-06-26",
              "2000-06-27",
              "2000-06-28",
              "2000-06-29",
              "2000-06-30",
              "2000-07-01",
              "2000-07-02",
              "2000-07-03",
              "2000-07-04",
              "2000-07-05",
              "2000-07-06",
              "2000-07-07",
              "2000-07-08",
              "2000-07-09",
              "2000-07-10",
              "2000-07-11",
              "2000-07-12",
              "2000-07-13",
              "2000-07-14",
              "2000-07-15",
              "2000-07-16",
              "2000-07-17",
              "2000-07-18",
              "2000-07-19",
              "2000-07-20",
              "2000-07-21",
              "2000-07-22",
              "2000-07-23",
              "2000-07-24",
            ],
            gridIndex: 1,
          },
          {
            data: [
              "2000-06-05",
              "2000-06-06",
              "2000-06-07",
              "2000-06-08",
              "2000-06-09",
              "2000-06-10",
              "2000-06-11",
              "2000-06-12",
              "2000-06-13",
              "2000-06-14",
              "2000-06-15",
              "2000-06-16",
              "2000-06-17",
              "2000-06-18",
              "2000-06-19",
              "2000-06-20",
              "2000-06-21",
              "2000-06-22",
              "2000-06-23",
              "2000-06-24",
              "2000-06-25",
              "2000-06-26",
              "2000-06-27",
              "2000-06-28",
              "2000-06-29",
              "2000-06-30",
              "2000-07-01",
              "2000-07-02",
              "2000-07-03",
              "2000-07-04",
              "2000-07-05",
              "2000-07-06",
              "2000-07-07",
              "2000-07-08",
              "2000-07-09",
              "2000-07-10",
              "2000-07-11",
              "2000-07-12",
              "2000-07-13",
              "2000-07-14",
              "2000-07-15",
              "2000-07-16",
              "2000-07-17",
              "2000-07-18",
              "2000-07-19",
              "2000-07-20",
              "2000-07-21",
              "2000-07-22",
              "2000-07-23",
              "2000-07-24",
            ],
            gridIndex: 2,
          },
        ],
        yAxis: [
          {},
          {
            gridIndex: 1,
          },
          {
            gridIndex: 2,
          },
        ],
        grid: [
          {
            top: "0%",
            bottom: "66%",
          },
          {
            top: "33%",
            bottom: "33%",
          },
          {
            top: "66%",
            bottom: "0%",
          },
        ],
        series: [
          {
            type: "line",
            showSymbol: false,
            data: [
              116, 129, 135, 86, 73, 85, 73, 68, 92, 130, 245, 139, 115, 111,
              309, 206, 137, 128, 85, 94, 71, 106, 84, 93, 85, 73, 83, 125, 107,
              82, 44, 72, 106, 107, 66, 91, 92, 113, 107, 131, 111, 64, 69, 88,
              77, 83, 111, 57, 55, 60,
            ],
          },
          {
            type: "line",
            showSymbol: false,
            data: [
              116, 129, 135, 86, 73, 85, 73, 68, 92, 130, 245, 139, 115, 111,
              309, 206, 137, 128, 85, 94, 71, 106, 84, 93, 85, 73, 83, 125, 107,
              82, 44, 72, 106, 107, 66, 91, 92, 113, 107, 131, 111, 64, 69, 88,
              77, 83, 111, 57, 55, 60,
            ],
            xAxisIndex: 1,
            yAxisIndex: 1,
          },
          {
            type: "line",
            showSymbol: false,
            data: [
              116, 129, 135, 86, 73, 85, 73, 68, 92, 130, 245, 139, 115, 111,
              309, 206, 137, 128, 85, 94, 71, 106, 84, 93, 85, 73, 83, 125, 107,
              82, 44, 72, 106, 107, 66, 91, 92, 113, 107, 131, 111, 64, 69, 88,
              77, 83, 111, 57, 55, 60,
            ],
            xAxisIndex: 2,
            yAxisIndex: 2,
          },
        ],
      };
    },
  },
};
</script>
  
  <style scoped>
.inventory-item-pie-chart {
  width: 100%;
  font-family: Roboto, sans-serif;
}
</style>
  